import { useState } from 'react';

const Ubuntu = () => {
  const data = {
    Crops: {
      options: ['Maize'],
      description: `Maize: What you should know before starting a maize farm – (Maize also known as corn or mielies) Maize farming is an agricultural process of growing maize (corn) in fields. Maize is the most important food crop in the world, and is the most important grain crop in developing countries.`,
    },
    Livestock: {
      options: ['Cattle', 'Goats', 'Poultry'],
      description: `Livestock farming involves raising animals like cattle, goats, and poultry for food or other products. Each type requires different methods, care, and resources.`,
    },
    Irrigation: {
      options: ['Drip Irrigation'],
      description: `Irrigation is essential for consistent crop growth, especially in arid regions. Drip irrigation helps save water and ensures roots receive moisture directly.`,
    },
    Isrrigation: {
      options: ['Drip Irrigation'],
      description: `Irrigation is essential for consistent crop growth, especially in arid regions. Drip irrigation helps save water and ensures roots receive moisture directly.`,
    },
  };

  const tabs = Object.keys(data);
  const [activeTab, setActiveTab] = useState('Crops');

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  return (
    <div className="bg-white">
      <div className="md:px-24 px-4 md:pt-5">
        <a href="/Communities">
          <h1 className="text-[#FDBD26] font-bold text-[12px] md:text-[36px]">Communities</h1>
        </a>

        <div className="flex gap-2 flex-unwrap mb-4 mt-4 md:mt-10">
          {tabs.map((tab) => (
            <button
              key={tab}
              onClick={() => handleTabClick(tab)}
              className={`text-[8px] md:text-[28px] leading-tight md:leading-snug w-[65px] h-[30px] md:w-full md:h-[90px] font-bold text-left md:px-4 px-1 py-1 rounded-md border-b-[3px] ${
                activeTab === tab
                  ? 'border-[#FDBD26] text-black'
                  : 'border-[#FDBD26] text-black'
              }`}
            >
              Ubuntu <br /> Community
            </button>
          ))}
        </div>

        <div className="relative rounded-lg overflow-hidden shadow-md h-[150px] md:h-[560px] md:mt-10 mt-2">
          <img
            src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745358042/image_53_y8wy1h.png"
            alt="Shop from community"
            className="object-cover w-full h-[150px] md:h-[500px]"
          />
          <div className="absolute bottom-0 left-0 right-0 bg-[#2E453D] text-white flex justify-between items-center">
            <div className="px-2 md:px-10 py-2 md:py-4">
              <div className="font-bold text-[8px] md:text-[24px]">AFRIKA COMMUNITY</div>
              <div className="text-[6px] md:text-[24px] -mt-1 md:mt-1">
                Donate to support community project
              </div>
            </div>
          </div>
        </div>

        {/* Poultry Farm Guide */}
        <div className="md:mt-16 mt-8 mb-10 -space-y-2 text-[12px] md:text-[48px]">
          <p className="font-bold text-lg md:text-[48px]">🐔 How to Start a Poultry Farm in Namibia</p>
          <br />
          <p><span className="font-bold">✅ 1. Choose Your Poultry Type</span></p>
          <p className='ml-6 font-medium'>Decide what you want to farm:</p>
          <ul className="list-disc ml-8 md:ml-16 font-medium">
            <li>Broilers – Raised for meat (fast-growing, ready in 6–8 weeks)</li>
            <li>Layers – Raised for eggs (start laying around 5–6 months old)</li>
            <li>Dual-purpose breeds – For both meat and eggs (good for smallholders)</li>
          </ul>
          <div className='md:h-16 h-3'></div>
          <p className="font-bold mt-2">👉 Tip: Broilers = quick returns, Layers = long-term income</p>

          <p><span className="font-bold">📍 2. Pick a Suitable Location</span></p>
          <p className='ml-6 font-medium'>Look for:</p>
          <ul className="list-disc ml-8 md:ml-16 font-medium">
            <li>Good drainage (avoid water-logged areas)</li>
            <li>Access to clean water and feed supply</li>
            <li>Safe from predators</li>
            <li>Distance from residential areas (due to smell, noise)</li>
          </ul>
          <p className="font-bold mt-2">👉 You can start small in your backyard or family plot</p>

          <p><span className="font-bold">🏗 3. Build the Chicken House (Poultry House)</span></p>
          <p className='font-bold ml-0'>Key features:</p>
          <ul className="list-disc ml-8 md:ml-16 font-medium">
            <li>Ventilation: fresh air = healthy birds</li>
            <li>Security: protect from snakes, dogs, thieves</li>
            <li>Cleanable: makes disease control easier</li>
          </ul>
          <p className="font-bold ml-0 mt-2">🐣 Space Needed:</p>
          <ul className="list-disc ml-8 md:ml-16 font-medium">
            <li>Broilers: ~10 birds per 1 square meter</li>
            <li>Layers: ~6–8 birds per 1 square meter</li>
          </ul>

          <p><span className="font-bold">🍽 4. Get Chicks & Equipment</span></p>
          <ul className="list-disc ml-8 md:ml-16 font-medium">
            <li>Day-old chicks (buy from certified hatcheries)</li>
            <li>Feeders & drinkers</li>
            <li>Heating source (especially for chicks)</li>
            <li>Vaccination and medication supplies</li>
          </ul>
          <p className="font-bold ml-4">👉 Ask for a vaccination schedule when you buy chicks!</p>

          <p><span className="font-bold">🍗 5. Feed & Manage Properly</span></p>
          <ul className="list-disc ml-8 md:ml-16 font-medium">
            <li>Feed according to age (starter, grower, finisher for broilers)</li>
            <li>Keep water clean and fresh</li>
            <li>Maintain hygiene (regular cleaning)</li>
            <li>Observe birds daily for signs of sickness</li>
          </ul>

          <p><span className="font-bold">💸 6. Market Your Poultry</span></p>
          <p className='ml-6 font-medium'>Think about:</p>
          <ul className="list-disc ml-8 md:ml-16 font-medium">
            <li>Selling to local butcheries, restaurants, or individuals</li>
            <li>Selling at open markets</li>
            <li>Partnering with school feeding programs</li>
            <li>Creating your own brand for eggs or dressed chickens</li>
          </ul>
          <p className="font-bold ml-0 mt-2">👉 Tip: Offer home delivery in your area for extra convenience</p>

          <p><span className="font-medium">🧾 7. Budget & Plan for Profit</span></p>
          <div className='md:h-16 h-3'></div>

          <p className="font-medium mt-2">Example for broilers (100 chicks):</p>
          <ul className="list-disc ml-8 md:ml-16 font-medium">
            <li>Chicks: N$1,000</li>
            <li>Feed: N$2,500</li>
            <li>Vaccines & Meds: N$300</li>
            <li>Equipment & housing: N$2,000</li>
            <li>Total Cost: ~N$5,800</li>
            <li>Sale (at N$70–N$80 each): ~N$7,000–N$8,000</li>
          </ul>
          <p className="ml-4 font-medium">
            💡 Profit depends on management and feed cost control.
          </p>

          <p><span className="font-bold">📚 Optional: Get Training or Mentorship</span></p>
          <ul className="list-disc ml-8 md:ml-16 font-medium">
            <li>Visit local agricultural extension officers</li>
            <li>Join WhatsApp farming groups</li>
            <li>Attend training from Agri colleges or NGOs</li>
          </ul>
        </div>

        <div className="md:h-40 h-10" />
      </div>
    </div>
  );
};

export default Ubuntu;
